import styled from 'styled-components';

export const StyledHeader = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  padding: 10px 15px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 20px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.3);
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.1);
  background: var(--body-bg);
  z-index: 3;

  @media (min-width: 1200px) {
    padding: 15px 15px;
  }

  button {
    font-weight: 600;
  }
`;
